const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  GARBAGE: '/garbage-collection',
  MANAGEMENT: '/management',
};

export const paths = {
  auth: {
    login: `${ROOTS.AUTH}/login`,
    verify: `${ROOTS.AUTH}/verify`,
    newPassword: `${ROOTS.AUTH}/new-password`,
    forgotPassword: `${ROOTS.AUTH}/forgot-password`,
  },

  dashboard: {
    general: {
      dashboardOverview: `${ROOTS.DASHBOARD}/dashboard-overview`,
      report: `${ROOTS.DASHBOARD}/report`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user/list`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/detail`,
    },
    userContact: {
      root: `${ROOTS.DASHBOARD}/user-contact/list`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/user-contact/${id}/edit`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/user-contact/${id}/detail`,
    },
    node: {
      root: `${ROOTS.DASHBOARD}/node/list`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/node/${id}/edit`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/node/${id}/detail`,
    },
    organize: {
      root: `${ROOTS.DASHBOARD}/organize/list`,
      code: `${ROOTS.DASHBOARD}/organize/code`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/organize/${id}/edit`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/organize/${id}/detail`,
    },
    token: {
      root: `${ROOTS.DASHBOARD}/token/list`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/token/${id}/edit`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/token/${id}/detail`,
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order/list`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/order/${id}/detail`,
    },
    article: {
      root: `${ROOTS.DASHBOARD}/article/list`,
      category: `${ROOTS.DASHBOARD}/article/category/list`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/article/${id}/edit`,
      category_edit: (id: string) => `${ROOTS.DASHBOARD}/article/category/${id}/edit`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/article/${id}/detail`,
      category_detail: (id: string) => `${ROOTS.DASHBOARD}/article/category/${id}/detail`,
    },
    quest: {
      root: `${ROOTS.DASHBOARD}/quest/list`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/quest/${id}/edit`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/quest/${id}/detail`,
    },
    questReward: {
      root: `${ROOTS.DASHBOARD}/quest-reward/list`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/quest-reward/${id}/edit`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/quest-reward/${id}/detail`,
    },
    reward: {
      root: `${ROOTS.DASHBOARD}/reward/list`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/reward/${id}/edit`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/reward/${id}/detail`,
    },
    redeam: {
      root: `${ROOTS.DASHBOARD}/redeam/list`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/redeam/${id}/edit`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/redeam/${id}/detail`,
    },
    garbage: {
      root: `${ROOTS.DASHBOARD}/garbage/list`,
      garbage_type: `${ROOTS.DASHBOARD}/garbage/garbage-type/list`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/garbage/${id}/edit`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/garbage/${id}/detail`,
    },
    notification: `${ROOTS.DASHBOARD}/notification`,
    setting: `${ROOTS.DASHBOARD}/setting`,
  },

  garbageCollection: {
    garbageLog: {
      root: `${ROOTS.GARBAGE}/garbage-collection-log/list`,
      detail: (id: string) => `${ROOTS.GARBAGE}/garbage-collection-log/${id}/detail`,
    },
    garbageManageBy: {
      root: `${ROOTS.GARBAGE}/garbage-collection-manage-by/list`,
      edit: (id: string) => `${ROOTS.GARBAGE}/garbage-collection-manage-by/${id}/edit`,
      detail: (id: string) => `${ROOTS.GARBAGE}/garbage-collection-manage-by/${id}/detail`,
    },
    garbageManageType: {
      root: `${ROOTS.GARBAGE}/garbage-collection-manage-type/list`,
      edit: (id: string) => `${ROOTS.GARBAGE}/garbage-collection-manage-type/${id}/edit`,
      detail: (id: string) => `${ROOTS.GARBAGE}/garbage-collection-manage-type/${id}/detail`,
    },
    locationType: {
      root: `${ROOTS.GARBAGE}/garbage-collection-location-type/list`,
      edit: (id: string) => `${ROOTS.GARBAGE}/garbage-collection-location-type/${id}/edit`,
      detail: (id: string) => `${ROOTS.GARBAGE}/garbage-collection-location-type/${id}/detail`,
    },
    location: {
      root: `${ROOTS.GARBAGE}/garbage-collection-location/list`,
      edit: (id: string) => `${ROOTS.GARBAGE}/garbage-collection-location/${id}/edit`,
      detail: (id: string) => `${ROOTS.GARBAGE}/garbage-collection-location/${id}/detail`,
    },
  },

  management: {
    theme: {
      root: `${ROOTS.MANAGEMENT}/theme/list`,
      create: `${ROOTS.MANAGEMENT}/theme/create`,
      edit: (id: string) => `${ROOTS.MANAGEMENT}/theme/${id}/edit`,
      delete: (id: string) => `${ROOTS.MANAGEMENT}/theme/${id}/delete`,
    },
    banner: {
      root: `${ROOTS.MANAGEMENT}/banner/list`,
      create: `${ROOTS.MANAGEMENT}/banner/create`,
      edit: (id: string) => `${ROOTS.MANAGEMENT}/banner/${id}/edit`,
      delete: (id: string) => `${ROOTS.MANAGEMENT}/banner/${id}/delete`,
    },
    invitationCode: {
      root: `${ROOTS.MANAGEMENT}/invitation-code/list`,
    },
    invitationCodeLog: {
      root: `${ROOTS.MANAGEMENT}/invitation-code-log/list`,
    },
  },
};
